import React, { useEffect } from 'react';

const FlameMatrix = ({ className = '' }) => {
  useEffect(() => {
    const container = document.createElement('div');
    container.className = `fixed inset-0 overflow-hidden pointer-events-none z-0 ${className}`;
    document.body.appendChild(container);

    const createFlames = () => {
      for (let i = 0; i < 5; i++) {
        const flame = document.createElement('div');
        flame.textContent = '🔥';
        flame.className = 'absolute text-fuckpepe-fire opacity-100 animate-burn';
        flame.style.left = `${Math.random() * 100}%`;
        flame.style.top = '-20px';
        flame.style.fontSize = `${Math.random() * 30 + 10}px`;
        container.appendChild(flame);

        const keyframes = [
          { transform: 'translateY(0)', opacity: 0.3 },
          { transform: `translateY(${window.innerHeight + 100}px)`, opacity: 0 }
        ];
        
        const animation = flame.animate(keyframes, {
          duration: Math.random() * 5000 + 3000,
          easing: 'linear'
        });

        animation.onfinish = () => flame.remove();
      }
    };

    // Create initial flames
    createFlames();

    // Continuous flame generation
    const flameInterval = setInterval(createFlames, 2000);

    return () => {
      clearInterval(flameInterval);
      document.body.removeChild(container);
    };
  }, [className]);

  return null;
};

export default FlameMatrix;
